import { Fragment, lazy, Suspense } from "react";
import { FormProvider } from "react-hook-form";

import StepHeader from "@ctv/shared/components/Layout/StepHeader";
import Snackbar from "@ctv/shared/contexts/Snackbar";

import { RequiredDocumentProvider } from "../../_contexts/RequiredDocumentContext";
import RegistrationDocuments from "../RegistrationDocuments";
import RegistrationPaymentMethod from "../RegistrationPaymentMethod";
import RegistrationReview from "../RegistrationReview";
import { SUBMIT_STEP } from "./helper";
import useRegistrationWizard from "./hook";

const RegistrationForm = lazy(() => import("../RegistrationForm"));
const RegistrationOfferingDetails = lazy(
  () => import("../RegistrationOfferingDetails")
);

export default function RegistrationWizard() {
  const { step, steps, methods, onSubmit, onClickBack, onClickContinue } =
    useRegistrationWizard();
  return (
    <Fragment>
      <StepHeader current={step} steps={steps} />
      <Snackbar />
      <FormProvider {...methods}>
        <Suspense fallback={null}>
          {step === 0 && <RegistrationForm onSubmit={onSubmit} />}
          {step === 1 && (
            <RegistrationOfferingDetails
              onClickBack={onClickBack}
              onClickContinue={onClickContinue}
            />
          )}
          {step === 2 && (
            <RegistrationPaymentMethod
              onSubmit={onSubmit}
              onClickBack={onClickBack}
            />
          )}
          {step === 3 && (
            <RequiredDocumentProvider>
              <RegistrationDocuments
                onSubmit={onSubmit}
                onClickBack={onClickBack}
              />
            </RequiredDocumentProvider>
          )}
          {step === SUBMIT_STEP && (
            <RequiredDocumentProvider>
              <RegistrationReview
                onClickBack={onClickBack}
                onSubmit={onSubmit}
              />
            </RequiredDocumentProvider>
          )}
        </Suspense>
      </FormProvider>
    </Fragment>
  );
}
